import assignmentService from 'ApiService/Teacher/Assignment';
import testService from 'ApiService/Teacher/TestService';
import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import ConfirmationModal from 'pages/Common/ConfirmationModal';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import StepperControl from 'views/admin/main/users/newUser/components/Admissions/StepperControl';
import Stepper from 'views/admin/main/users/newUser/components/Stepper';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import AddQA from './Steps/AddQA';
import QAsummery from './Steps/QAsummery';
import SelectBatch from './Steps/SelectBatch';

const Index = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [batchNumber, setbatchNumber] = useState('');
  const [testData, setTestData] = useState({
    courseId: '',
    title: '',
    type: 'qa',
    questions: [
      {
        questionText: '',
        options: ['', '', '', ''],
        correctAnswer: '',
        marks: '',
      },
    ],
    assignedTo: [],
    courseName: '',
    completionTime: '',
  });
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [isModalOpenConfirmation, setIsModalOpenConfirmation] = useState(false);

  const router = useNavigate();
  const { state } = useContext(AuthContext);
  const steps = [
    { stepNo: 1, name: 'Course Info' },
    { stepNo: 2, name: 'Add Question' },
    { stepNo: 3, name: 'Summary' },
  ];

  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const response = await testService.getAllCourses();
      if (response.data.success) {
        setCourses(response.data.courses);
      } else {
        toast.error('Failed to fetch courses.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
    } finally {
      setLoadingCourses(false);
    }
  };
  const handleConfirmSubmit = () => {
    if (testData.title && testData.questions.length) {
      setIsModalOpenConfirmation(true);
    } else {
      toast.error('Please fill in all fields.');
    }
  };

  const handleSubmit = async () => {
    if (loading) return;
    const updatedQuestions = testData.questions.map((question) => {
      if (testData.type === 'qa') {
        delete question.options;
      }
      return question;
    });

    const dataToSubmit = { ...testData, questions: updatedQuestions };

    if (dataToSubmit.title && dataToSubmit.questions.length) {
      setLoading(true);
      try {
        const response = await assignmentService.createAssignment(dataToSubmit);
        if (response.data.success) {
          setTestData({
            courseId: '',
            title: '',
            type: 'qa',
            questions: [
              {
                questionText: '',
                options: ['', '', '', ''],
                correctAnswer: '',
                marks: '',
              },
            ],
            assignedTo: [],
            courseName: '',
            completionTime: '',
          });
          toast.success(response?.data?.message);
          setCurrentStep(1);
          setIsModalOpenConfirmation(false);
          fetchCourses();
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('Please fill in all fields.');
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const displayStep = (step) => {
    switch (step.stepNo) {
      case 1:
        return (
          <SelectBatch
            setLoading={setLoading}
            setDisable={setDisable}
            courses={courses}
            setTestData={setTestData}
            testData={testData}
            loadingCourses={loadingCourses}
          />
        );
      case 2:
        return (
          <AddQA
            setLoading={setLoading}
            setDisable={setDisable}
            testData={testData}
            setTestData={setTestData}
          />
        );
      case 3:
        return <QAsummery testData={testData} />;
      default:
        return null;
    }
  };

  const handleNext = async () => {
    if (disable) return;
    setLoading(true);
    setCurrentStep(currentStep + 1);
    setLoading(false);
  };

  const handleBack = () => {
    if (disable) return;
    setCurrentStep((cs) => cs - 1);
  };

  const handleKeyDown = (event) => {
    if (disable) return;

    if (event.key === 'Enter') {
      if (currentStep === 1) {
        handleNext();
      }
    } else if (event.key === 'ArrowLeft') {
      if (currentStep > 1) {
        handleBack();
      }
    } else if (event.key === 'ArrowRight') {
      if (currentStep < steps.length) {
        handleNext();
      }
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentStep, disable]);

  const handleClick = (direction) => {
    let newStep = currentStep;

    direction === 'next' ? newStep++ : newStep--;
    // check if steps are within bounds
    newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
  };

  return (
    <div className="md-mt-[3] mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
        <div className="-mt-[280px] w-full pb-10 md:-mt-[340px] md:px-[70px]">
          <Stepper steps={steps} currentStep={currentStep} />
        </div>
        <Card extra={'h-full mx-auto pb-3'}>
          <div className="rounded-[20px]">
            <UseContextProvider>
              {displayStep(steps[currentStep - 1])}
            </UseContextProvider>
          </div>
          {/* Navigation button */}
          <StepperControl
            handleClick={handleClick}
            currentStep={currentStep}
            steps={steps}
            loading={loading}
            handleSubmit={handleConfirmSubmit}
            disable={disable || loading}
          />
        </Card>
      </div>
      <ConfirmationModal
        isOpen={isModalOpenConfirmation}
        onClose={() => {
          if (!loading) setIsModalOpenConfirmation(false);
        }}
        onConfirm={handleSubmit}
        title="Confirm QA Assignment Creation"
        message="Are you sure you want to create this qa type assignment ?"
        confirmText={loading ? 'Processing...' : 'Yes, Create Assignment'}
        cancelText="Cancel"
        icon="info"
        disableConfirm={loading}
      />
    </div>
  );
};

export default Index;
